import { useNavigate } from 'react-router-dom';

import { LocationDetail } from 'hooks/useGetLocations';
import { useUpdateLocationHistory } from 'hooks/useUpdateLocationHistory';
import Icon, { Icons } from '../common/icons/Icon';

type LocationSearchResultProps = {
  iconName?: Icons;
  location: LocationDetail;
  onSelect?: () => any;
  save?: boolean;
  testid?: string;
};

function LocationSearchResult({
  iconName = Icons.LocationPin,
  location,
  onSelect,
  save,
  testid = 'location-search-result',
}: LocationSearchResultProps) {
  const navigate = useNavigate();
  const updateLocationHistory = useUpdateLocationHistory();

  const selectLocation = (): void => {
    onSelect && onSelect();
    if (save) {
      updateLocationHistory.mutate(location, {
        onSuccess: () => {
          navigate(`/forecasts/${location.lat}/${location.lon}`);
        },
      });
    } else {
      navigate(`/forecasts/${location.lat}/${location.lon}`);
    }
  };

  return (
    <div
      onClick={selectLocation}
      className="border-b border-b-slate-300/70 px-2 py-4 first:rounded-t-lg last:rounded-b-lg last:border-b-0 hover:cursor-pointer hover:bg-slate-100/70 dark:bg-slate-900 dark:hover:bg-slate-700"
      data-testid={testid}
    >
      <div className="flex items-baseline">
        <Icon name={iconName} fixedWidth size="sm" className="mr-2" />
        <div>{location.name}</div>
        {(location.region || location.country) && (
          <>
            <div className="mr-1">,</div>
            <div className="truncate text-sm text-slate-500">
              {location.region || location.country}
            </div>
          </>
        )}
      </div>
    </div>
  );
}

export default LocationSearchResult;
